/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_Title_TailInputs */

const en_platform_team_title_tail = /** @type {(inputs: Platform_Team_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or with a team?`)
};

const pl_platform_team_title_tail = /** @type {(inputs: Platform_Team_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z zespołem?`)
};

/**
* | output |
* | --- |
* | "or with a team?" |
*
* @param {Platform_Team_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_title_tail = /** @type {((inputs?: Platform_Team_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_title_tail(inputs)
	return en_platform_team_title_tail(inputs)
});